import React from 'react';

const ScrollToTop = ({ children, location }) => {
    // each time when url changes, reset window position to the top
    React.useEffect(() => window.scrollTo(0, 0), [location.pathname]);
    return children;
};

export default ScrollToTop;
